import Layout from '../../../components/layout/index'
import GraficoBarra from '../../../components/graficoBarra';
import GraficoPizza from '../../../components/graficoPizza';
import { ContainerCardsExplicativos, ContainerFiltrosEActions, ContainerGraficos, ContainerLayout, Grafico } from '../../Batismo/Dash/style';
import { ServicesDashboard as useServices } from './services'
import ModalFiltro from '../../../components/modalFiltros';
import SedeStackComponent from '../../Pg/DashboardPg/stacks/sedes';
import CadastrosStackComponent from './stack/cadastrados';
// import MembrosStackComponent from './stacks/membros';
// import TipoPgStackComponent from './stacks/tipospgs';
// import CelulaStackComponent from './stacks/celulas';

export default function DashboardPg() {

  const { getPessoasPorMinisterioSede, tipoDePg, todosRegistros, pessoasPorEstadoCivil, pessoasPorGenero, pessoasPorIdade, pessoasPorSede, totalDeCelulas } = useServices({
  });

  return (
    <>

        <ContainerLayout>
          <ContainerFiltrosEActions>
            <ModalFiltro>
              <></>
            </ModalFiltro>
          </ContainerFiltrosEActions>
          <ContainerCardsExplicativos>
            <SedeStackComponent objectWithValues={pessoasPorSede} />
            <CadastrosStackComponent objectWithValues={todosRegistros} />
            {/*
            <CelulaStackComponent
              objectWithValues={totalDeCelulas}
            />
            <TipoPgStackComponent
              objectWithValues={tipoDePg}
            /> */}
          </ContainerCardsExplicativos>
          <ContainerGraficos>
            <Grafico>
              <GraficoBarra
                titulo={"Participantes por Sede"}
                keyX='quantidade'
                value='sedes'
                keyForExctratTitles='nomesede'
                dados={pessoasPorSede ?? []}
                color={"#108dff"} />
            </Grafico>

            <Grafico>
              <GraficoBarra
                titulo={"Participantes por Idade"}
                keyX='quantidade'
                value='Medias'
                keyForExctratTitles='media'
                dados={pessoasPorIdade ?? []}
                color={"#108dff"} />
            </Grafico>
            <Grafico>
              <GraficoPizza
                title={'Participantes por Gênero'}
                cores={['#E8C29C', '#99E7FF', '#759', '#f00895', '#789456', '#963']}
                descricaoDados='quantidade'
                descricao='genero'
                dados={pessoasPorGenero ?? []}
              />
            </Grafico>
            <Grafico>
              <GraficoPizza
                title={'Estado Cívil'}
                cores={['#E8C29C', '#99E7FF', '#759', '#f00895', '#789456', '#963']}
                descricaoDados='quantidade'
                descricao='estadocivil'
                dados={pessoasPorEstadoCivil ?? []}
              />
            </Grafico>
          </ContainerGraficos>
        </ContainerLayout>

    </>
  )

}
